import { defineComponent as _defineComponent } from 'vue'
import { TitleOfferFragment } from '@/components/buybox/graphql/fragments/Offer.fragment';
import { useI18n } from '@/helpers/composables/useI18n';
import { computed } from 'vue';
import { PlanOffer } from '@/components/buybox-new/PromotionRowNew.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PromotionRowOfferLabel',
  props: {
    promotionOffer: null,
    packagePlan: null,
    isHighlighted: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
	promotionOffer: TitleOfferFragment | null;
	packagePlan: PlanOffer | null;
	isHighlighted?: boolean;
};



const { t } = useI18n();

const retailPrice = computed(() => {
	if (props.packagePlan?.retailPrice) return t('WEBAPP_THEN_X_PER_MONTH', { price: props.packagePlan.retailPrice });
	return null;
});

const freeTrialText = computed(() => {
	// for JWTV we have no package plan
	if (props.promotionOffer?.package.shortName === 'jwt') return t('WEBAPP_FREE');

	if (props.packagePlan?.durationDays) {
		return props.packagePlan.durationDays === 1
			? t('WEBAPP_1_DAY_FREE')
			: t('WEBAPP_X_DAYS_FREE', { days: props.packagePlan.durationDays });
	}
	return null;
});

return { __sfc: true,props, t, retailPrice, freeTrialText }
}

})